import { render } from "./ContractDetailsForm.vue?vue&type=template&id=ea87d4b0&scoped=true"
import script from "./ContractDetailsForm.vue?vue&type=script&lang=js"
export * from "./ContractDetailsForm.vue?vue&type=script&lang=js"

import "./ContractDetailsForm.vue?vue&type=style&index=0&id=ea87d4b0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea87d4b0"]])

export default __exports__